import React, {Component} from "react";

export default class AcceptRequest extends Component {
    componentWillMount() {
        const { hash } = this.props.location;

        const params = new URLSearchParams(hash);
        const access_token = params.get('#access_token');
        
        localStorage.setItem('access_token', access_token);
        window.close()
    }

    render() {
        return (<div></div>)
    }
}


// WEBPACK FOOTER //
// ./src/components/AcceptRequest.js